import { scrollToBase } from 'Core/actions/show';
import uiConfig from 'Models/uiConfig/uiConfig';
import scheduleIdleCallback from 'Modules/scheduleIdleCallback';
import { animateLinear } from 'Utils/animatePromise';

import { epicFromHandlers } from './common';

const widgets = new Map(
  uiConfig.widgetsConsideredInScroll.filter((w) => w.element?.offsetParent !== null).map((w) => [w, 0]),
);
const scrollDuration = 100;
const possibleDelay = 100;

export default epicFromHandlers(
  {
    [scrollToBase.type]({ state }) {
      if (state.show.infiniteScrollLoading) {
        return;
      }
      scheduleIdleCallback(
        () => {
          [...widgets.keys()].forEach((w) => widgets.set(w, getOffset(w)));

          const base = Math.min(...widgets.values()) - getScrollOffset();
          const { pageYOffset: current } = window;
          const final = Math.min(base, current);

          return animateLinear(current, final, (y) => window.scroll(0, y), scrollDuration);
        },
        { timeout: possibleDelay },
      );
    },
  },
  'requestScroll',
);

function getOffset({ element }: { element: Element | null }) {
  let offset = 0;
  let current = toHtmlElement(element);
  while (current) {
    offset += current.offsetTop;
    current = toHtmlElement(current.offsetParent);
  }
  return offset;
}

function getScrollOffset() {
  const stickyHeader = uiConfig.stickyHeaderSelector
    ? window.document.querySelector<HTMLElement>(uiConfig.stickyHeaderSelector)
    : null;
  if (stickyHeader) {
    let current: HTMLElement | null = stickyHeader;
    while (current) {
      const { position } = window.getComputedStyle(current);
      if (position === 'fixed' || position === 'sticky') {
        return stickyHeader.offsetHeight;
      }
      current = toHtmlElement(current.offsetParent);
    }
  }
  return 0;
}

function toHtmlElement(element: Element | null): HTMLElement | null {
  return element instanceof HTMLElement ? element : null;
}
